import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { Container, Row, Col, Nav } from 'react-bootstrap'
import dynamic from 'next/dynamic'

import navStyles from '@shared/components/commonNav/style.module.scss'
import styles from './style.module.scss'
import { pageHeaderLoader } from '@shared/libs/allLoader'
import Error from '@shared/components/error'
import { dateCheck, convertDateDDMT } from '@shared-submodule/utils'

import { useRouter } from 'next/router'
import IccRankingsCard from '@shared/components/iccRankingsCard'
import useWindowSize from '@shared/hooks/windowSize'
const Layout = dynamic(() => import('@shared/components/layout'))
const PageHeader = dynamic(() => import('@shared/components/pageHeader'), { loading: () => pageHeaderLoader() })
const ATSAds = dynamic(() => import('@shared/components/atsAds'), { ssr: false })

const iccRankings = ({ data, seoData, allData }) => {
  const router = useRouter()
  const [width] = useWindowSize()
  const initialCall = useRef(false)
  const [filter, setFilter] = useState({
    eRankType: router?.query?.rank || 'Teams',
    eGender: router?.query?.gender === 'women' ? 'W' : router?.query?.gender || 'M',
    nLimit: 120,
    nSkip: 0
  })
  useEffect(() => {
    setFilter({
      ...filter,
      eRankType: router?.query?.rank || 'Teams',
      eMatchType: 'Tests',
      eGender: router?.query?.gender === 'women' ? 'W' : router?.query?.gender || 'M'
    })
  }, [router?.query])

  useEffect(() => {
    initialCall.current = true
  }, [])
  function handleFilter(e) {
    let value = 'M'
    if (e?.target.innerHTML === 'Women') {
      value = 'W'
    } else {
      value = null
    }

    if (value) {
      const valueChanged = value === 'W' ? 'women' : value === 'M' ? 'men' : null
      if (router.query.rank) {
        router.push({ query: { gender: valueChanged || 'men', rank: router.query.rank } })
      } else {
        router.push({ query: { gender: valueChanged || 'men' } })
      }
    } else {
      if (router?.query?.rank) {
        router.push({ query: { rank: router?.query?.rank || 'Teams' } })
      } else {
        router.push({ query: {} })
      }
    }
  }
  const handleMatchFilter = e => {
    let value
    if (e?.target.innerHTML === 'Team') {
      value = ''
    } else if (e?.target.innerHTML === 'Batter') {
      value = 'Batsmen'
    } else if (e?.target.innerHTML === 'Bowler') {
      value = 'Bowlers'
    } else if (e?.target.innerHTML === 'All Rounder') {
      value = 'AllRounders'
    }
    if (value) {
      if (router.query.gender) {
        router.push({ query: { rank: value || 'Teams', gender: router.query.gender } })
      } else {
        router.push({ query: { rank: value || 'Teams' } })
      }
    } else {
      if (router.query.gender) {
        router.push({ query: { gender: router?.query?.gender || 'M' } })
      } else {
        router.push({ query: {} })
      }
    }
  }
  return (
    <Layout
      data={{
        oSeo: {
          ...seoData?.getSeoData,
          sTitle: 'ICC Rankings',
          sDescription:
            'Latest ICC Rankings of ODI, T20I and Tests. Catch the latest Sports News today, Sports news headlines today, Sports news in English which includes Breaking News, National Sports News Today, Current Sports, Live Sport including Live Cricket Score from a Cricket Match'
        }
      }}>
      <section className="common-section pb-5 pt-4">
        <ATSAds />
        <Container>
          <Row>
            <div className="left-content">
              <PageHeader name="ICC Cricket Rankings" />
              {data?.getRankings?.aResults?.[0]?.dUpdated && (
                <div className={`${styles.lastupdate} mb-2`}>
                  Last updated on {convertDateDDMT(dateCheck(data?.getRankings?.aResults?.[0].dUpdated))}
                </div>
              )}
              <Nav className={`${navStyles.commonNav} text-uppercase`} variant="pills">
                <Nav.Item className={navStyles.item}>
                  <a className={`${filter.eGender === 'M' && navStyles.active} text-capitalize nav-link`} onClick={handleFilter}>
                    Men
                  </a>
                </Nav.Item>
                <Nav.Item className={navStyles.item}>
                  <a className={`${filter.eGender === 'W' && navStyles.active}  text-capitalize nav-link`} onClick={handleFilter}>
                    Women
                  </a>
                </Nav.Item>
              </Nav>
              <Nav
                className={`${navStyles.commonNav} ${navStyles.pillsNav} ${styles.marginNav} justify-content-start flex-nowrap text-nowrap overflow-auto`}
                variant="pills">
                <Nav.Item className={navStyles.item}>
                  <a className={`${filter.eRankType === 'Teams' && navStyles.active} nav-link`} onClick={handleMatchFilter}>
                    Team
                  </a>
                </Nav.Item>
                <Nav.Item className={navStyles.item}>
                  <a className={`${filter.eRankType === 'Batsmen' && navStyles.active} nav-link`} onClick={handleMatchFilter}>
                    Batter
                  </a>
                </Nav.Item>
                <Nav.Item className={navStyles.item}>
                  <a className={`${filter.eRankType === 'Bowlers' && navStyles.active} nav-link`} onClick={handleMatchFilter}>
                    Bowler
                  </a>
                </Nav.Item>
                <Nav.Item className={navStyles.item}>
                  <a className={`${filter.eRankType === 'AllRounders' && navStyles.active} nav-link`} onClick={handleMatchFilter}>
                    All Rounder
                  </a>
                </Nav.Item>
              </Nav>

              <section className={styles.awardsTable}>
                <Row>
                  <Col className="mt-2 mw-33">
                    <IccRankingsCard data={allData?.dataOdis?.getRankings?.aResults} cardtitle={'ODI'} queryType={'Odis'} />
                  </Col>
                  <Col className="mt-2 mw-33">
                    <IccRankingsCard data={allData?.dataT20s?.getRankings?.aResults} cardtitle={'T20I'} queryType={'T20s'} />
                  </Col>
                  {router?.query?.gender === 'women' ? (
                    <>
                      <Col className={`${styles.dSMNone} mt-2`}></Col>
                    </>
                  ) : (
                    <>
                      <Col className="mt-2 mw-33">
                        <IccRankingsCard data={allData?.dataTests?.getRankings?.aResults} cardtitle={'TEST'} queryType={'Tests'} />
                      </Col>
                    </>
                  )}
                  {/* <Col className={`${styles.dSMNone} mt-3`}>
                    {(router?.query?.gender === 'women') ? (<></>) : (<>
                      <IccRankingsCard data={allData?.dataTests?.getRankings?.aResults} cardtitle={'TEST'} queryType={'Tests'} />
                    </>)}
                  </Col> */}
                </Row>
              </section>
            </div>
          </Row>
        </Container>
        {/* testing for now  */}
        <p></p>
        <p></p>
        <p></p>
        <div>
          {width > 767 ? (
            <script src="https://cdn.fcp.codes/embed-code-template/embed-code-template.js#CHANNEL_9201c8b7-54b3-454d-be98-b50f5d3d8475"></script>
          ) : (
            <script src="https://cdn.fcp.codes/embed-code-template/embed-code-template.js#CHANNEL_ae015dc8-98f4-41a9-8f3a-5746e78fffbc"></script>
          )}
        </div>
      </section>
    </Layout>
  )
}

iccRankings.propTypes = {
  data: PropTypes.object,
  allData: PropTypes.object
}

export async function getServerSideProps({ res, resolvedUrl, query }) {
  try {
    res.setHeader('Cache-Control', 'public, max-age=420')

    const queryGraphql = (await import('@shared/components/queryGraphql')).default
    const GET_SEO_DATA = (await import('@graphql/article/article.query')).GET_SEO_DATA
    const { checkRedirectionStatus } = await import('@shared-submodule/utils')
    const { allRoutes } = await import('@shared-submodule/sm-constants/allRoutes')
    const { data: seoData } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: allRoutes.iccRankings?.slice(1) } })
    // Check Redirection
    const { redirectStatus, eCode, returnObj, props } = checkRedirectionStatus(seoData?.getSeoData)
    if (redirectStatus && props) {
      res.statusCode = eCode
      return { props }
    } else if (redirectStatus) return returnObj

    const RANKINGS = (await import('@graphql/globalwidget/rankings.query')).RANKINGS
    const { data } = await queryGraphql(RANKINGS, {
      input: {
        eMatchType: query?.match || 'Odis',
        eRankType: query?.rank || 'Teams',
        eGender: query?.gender === 'women' ? 'W' : query?.rank === 'men' ? 'M' : 'M' || 'M',
        nLimit: 10,
        nSkip: 0
      }
    })
    const { data: dataOdis } = await queryGraphql(RANKINGS, {
      input: {
        eMatchType: 'Odis',
        eRankType: query?.rank || 'Teams',
        eGender: query?.gender === 'women' ? 'W' : query?.rank === 'men' ? 'M' : 'M' || 'M',
        nLimit: 10,
        nSkip: 0
      }
    })
    const { data: dataT20s } = await queryGraphql(RANKINGS, {
      input: {
        eMatchType: 'T20s',
        eRankType: query?.rank || 'Teams',
        eGender: query?.gender === 'women' ? 'W' : query?.rank === 'men' ? 'M' : 'M' || 'M',
        nLimit: 10,
        nSkip: 0
      }
    })
    const { data: dataTests } = await queryGraphql(RANKINGS, {
      input: {
        eMatchType: 'Tests',
        eRankType: query?.rank || 'Teams',
        eGender: query?.gender === 'women' ? 'W' : query?.rank === 'men' ? 'M' : 'M' || 'M',
        nLimit: 10,
        nSkip: 0
      }
    })
    const allData = { dataOdis, dataT20s, dataTests }
    return {
      props: {
        data,
        seoData,
        allData
      }
    }
  } catch (e) {
    res.setHeader('Cache-Control', 'no-cache')
    const handleApiError = (await import('@shared-submodule/utils')).handleApiError
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}

export default Error(iccRankings)
